module.exports = __webpack_public_path__ + "img/cd.b43f872e.svg";